// keep imports sorted by from ...
import { initialState as auth } from '@/auth'
import { initialState as companyJobs } from '@/companyJobs'
import { initialState as company } from '@/companyProfile'
import { initialState as errorPage } from '@/errorPage'
import { initialState as internalLinks } from '@/internalLinks'
import { initialState as jobapplication } from '@/jobapplication'
import { initialState as job } from '@/jobDetail'
import { initialState as jobmail } from '@/jobmail'
import { initialState as jobmailActivateError } from '@/jobmailActivateError'
import { initialState as jobmailUnsubscribePage } from '@/jobmailUnsubscribePage'
import { initialState as landingPage } from '@/landingPage'
import { initialState as landingPageCatalog } from '@/landingPageCatalog'
import { initialState as toast } from '@/notifications'
import { initialState as page } from '@/page'
import { initialState as ratingWidget } from '@/ratingWidget'
import { initialState as results } from '@/results'
import { initialState as search } from '@/search'
import { initialState as share } from '@/share'
import { initialState as similarJobs } from '@/similarJobs'
import { initialState as spellcheck } from '@/spellcheck'
import { initialState as tracking } from '@/tracking'
import { initialState as user } from '@/user'

// converts prepared state to actual initial state
// keep sorted by key
export default (preparedState) => ({
  auth: auth(preparedState),
  company: company(preparedState),
  companyJobs: companyJobs(preparedState),
  errorPage: errorPage(preparedState),
  job: job(preparedState),
  jobapplication: jobapplication(preparedState),
  jobmail: jobmail(preparedState),
  jobmailActivateError: jobmailActivateError(preparedState),
  jobmailUnsubscribePage: jobmailUnsubscribePage(preparedState),
  landingPage: landingPage(preparedState),
  landingPageCatalog: landingPageCatalog(preparedState),
  page: page(preparedState),
  results: results(preparedState),
  search: search(preparedState),
  share: share(preparedState),
  similarJobs: similarJobs(preparedState),
  spellcheck: spellcheck(preparedState),
  toast: toast(preparedState),
  tracking: tracking(preparedState),
  user: user(preparedState),
  ratingWidget: ratingWidget(preparedState),
  internalLinks: internalLinks(preparedState)
})
